<div class="component-container" #pdfContent>
  <div class="container">
        <!-- Info Block -->
        <div class="info-block">
            <div class="info-header">
                <div class="company-info">
                    <h1>TransLogistics Corp</h1>
                    <p>Transportation & Logistics Solutions</p>
                </div>
                <div class="report-date">
                    Report Generated: {{ today | date: 'medium'}}
                </div>
            </div>
            
            <div class="info-grid">
                <div class="info-section">
                    <h3>Employee Information</h3>
                    <div class="info-item">
                        <span class="info-label">Name:</span>
                        <span class="info-value">John Martinez</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Employee ID:</span>
                        <span class="info-value">EMP-2024-0847</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Department:</span>
                        <span class="info-value">Logistics Operations</span>
                    </div>
                </div>
                
                <div class="info-section">
                    <h3>Location & Shift</h3>
                    <div class="info-item">
                        <span class="info-label">Site:</span>
                        <span class="info-value">Distribution Center A</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Location:</span>
                        <span class="info-value">Houston, TX - Warehouse 3</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Shift Start:</span>
                        <span class="info-value">06:00 AM</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Shift End:</span>
                        <span class="info-value">14:00 PM</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Data Table -->
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Move No.</th>
                        <th>Trailer #</th>
                        <th>Carrier</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Status</th>
                        <th>Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let move of moves | slice:startIndex:endIndex; let i = index;">
                        <td>{{ i + 1 }}</td>
                        <td>{{ move.end.trailer.trailer }}</td>
                        <td>{{ move.end.trailer.carrier }}</td>
                        <td>{{ move.start.location }}</td>
                        <td>{{ move.end.location }}</td>
                        <td><span class="status-badge status-completed">{{ move.status }}</span></td>
                        <td>{{ move.completed }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="page-footer">
            <button mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
            <button mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>

            <p>Page {{ currentPage }} of {{ totalPages }} | Total Records: {{ moves.length }} | Generated by Yard Hostle Report System</p>
            <button mat-icon-button color="primary" (click)="sendEmail()"> <mat-icon>mail</mat-icon></button>
            <button mat-icon-button color="accent" (click)="download()"> <mat-icon>download</mat-icon></button>
        </div>
</div>